const SAVE = 'SAVE_INFO_PRODUCT';

export function infoProductReducer (state = [], action) {
    switch (action.type) {
        case SAVE:
            return action.payload;
        default:
            return state;
    }
}